export const styles = {
  main: {
    backgroundColor: '#f6f9fc',
    fontFamily:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif',
  },
  container: {
    backgroundColor: '#ffffff',
    border: '1px solid #f0f0f0',
    borderRadius: '5px',
    margin: '0 auto',
    padding: '45px',
    marginBottom: '64px',
    maxWidth: '500px',
  },
  heading: {
    fontSize: '24px',
    letterSpacing: '-0.5px',
    lineHeight: '1.3',
    fontWeight: '600',
    color: '#484848',
    margin: '0 0 20px',
    padding: '0',
  },
  text: {
    fontSize: '16px',
    lineHeight: '26px',
    fontWeight: '400',
    color: '#484848',
    margin: '16px 0',
  },
  button: {
    backgroundColor: '#000000',
    borderRadius: '5px',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
    textDecoration: 'none',
    textAlign: 'center' as const,
    display: 'block',
    width: '100%',
    padding: '14px 20px',
    margin: '30px 0',
  },
  link: {
    color: '#2754C5',
    fontSize: '14px',
    textDecoration: 'underline',
    wordBreak: 'break-all' as const,
  },
  hr: {
    borderColor: '#e6ebf1',
    margin: '30px 0',
  },
  footer: {
    fontSize: '14px',
    lineHeight: '24px',
    color: '#9ca2ac',
    textAlign: 'center' as const,
    margin: '0',
  },
  code: {
    display: 'inline-block',
    padding: '16px',
    width: '100%',
    backgroundColor: '#f4f4f4',
    borderRadius: '5px',
    border: '1px solid #eee',
    fontSize: '14px',
    fontFamily: 'monospace',
    textAlign: 'center' as const,
    margin: '24px 0',
  },
}